import React from 'react'
import { SelectAndLinkContextValue } from './SelectAndLink.types'

export const SelectAndLinkContext =
  React.createContext<SelectAndLinkContextValue | null>(null)
